{
  "salon-details-page": {
    "buttons": {
      "next": "NEXT"
    },
    "meta": {
      "description": "Visit salon {{salon}} - {{address}}, book appointment online 24/7 and get great discounts"
    }
  }
}
